import { createSelector } from 'redux-bundler';

// General Page is Loading
export const selectGeneralPageIsLoading = createSelector(
  'selectFreshCurrentOrganization',
  'selectFreshCurrentOrganizationDetails',
  (freshCurrentOrganization, freshCurrentOrganizationDetails) =>
    !freshCurrentOrganization || !freshCurrentOrganizationDetails,
);

// Teams Page is Loading
export const selectTeamPageIsLoading = createSelector(
  'selectFreshCurrentOrganizationBoards',
  'selectFreshCurrentOrganizationTeam',
  (freshCurrentOrganizationBoards, freshCurrentOrganizationTeam) =>
    !freshCurrentOrganizationBoards || !freshCurrentOrganizationTeam,
);

// Workspace Page is Loading
export const selectWorkspacePageIsLoading = createSelector(
  'selectFreshCurrentOrganizationBoards',
  'selectFreshCurrentOrganizationTeam',
  (freshCurrentOrganizationBoards, freshCurrentOrganizationTeam) =>
    !freshCurrentOrganizationBoards || !freshCurrentOrganizationTeam,
);
